import template from './cancelled_shipments.html';
import controller from './cancelled_shipments.controller';
import './cancelled_shipments.scss';

let branchManagementCancelledShipmentsComponent = {
    restrict: "E",
    binding: {},
    template,
    controller
}

export default branchManagementCancelledShipmentsComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/cancelled_shipments/cancelled_shipments.component.js